import { request } from "./HttpService";

export function fetchPeerReviews() {
    return request("GET", "/peer-review/all");
}

export function fetchPeerReview(id) {
    return request("GET", `/peer-review/${id}`);
}

export function fetchPeerReviewByManuscript(manuscriptId) {
    return request("GET", `/peer-review/manuscript/${manuscriptId}`);
}

export function submitPeerReview(manuscriptId, notes) {
    return request("POST", "/peer-review/submit", { manuscriptId, notes });
}

export function cancelPeerReview(id) {
    return request("DELETE", `/peer-review/cancel/${id}`);
}

export function fetchEligibleManuscripts() {
    return request("GET", "/peer-review/eligible");
}

export function fetchReviewers() {
    return request("GET", "/peer-review/reviewers");
}

export function fetchReviewFeedback(peerReviewId) {
    return request("GET", `/peer-review/feedback/${peerReviewId}`);
}
